import { createContext, useContext } from 'react';
import type { components } from '@gftg/api-client';

/** Who is signed in, as the API describes her. There is no local copy — see `SessionProvider`. */
export type Session = components['schemas']['AttendeeMeDto'];

export interface SessionContextValue {
  session: Session | null;
  /** True only while the first `GET /auth/me` is in flight, so the gate can wait for an answer. */
  isPending: boolean;
  signOut: () => void;
  isSigningOut: boolean;
}

export const SessionContext = createContext<SessionContextValue | null>(null);

export function useSession(): SessionContextValue {
  const value = useContext(SessionContext);
  if (!value) {
    throw new Error('useSession must be used inside SessionProvider');
  }
  return value;
}

/**
 * DATA-06 reaches the avatar: a registration can arrive with only a first name, or with none at
 * all, and an empty circle is worse than one letter. Falls back to the address for the same reason
 * the API's own label does.
 */
export function initials(session: Session): string {
  const fromName = `${session.firstName.at(0) ?? ''}${session.lastName.at(0) ?? ''}`.trim();
  const letters = fromName.length > 0 ? fromName : (session.email?.at(0) ?? '');
  return letters.toUpperCase();
}
